export const SET_INITIALISED = 'app/SET_INITIALISED';

export const SET_LOADING = 'app/SET_LOADING';

export const SET_DATA = 'app/SET_DATA';

export const SET_BASEPATH = 'app/SET_BASEPATH';

export const SET_BASE_BREADCRUMB = 'app/SET_BASE_BREADCRUMB';

export const ADD_TO_HISTORY = 'app/ADD_TO_HISTORY';

export const SET_ERROR = 'app/SET_ERROR';
